import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const DeleteProfExams = () => {
    const [professionalExams, setProfessionalExams] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchDeletedProfExams();
    }, []);

    const fetchDeletedProfExams = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/professionalExams/deleted');
            const data = await response.json();
            setProfessionalExams(data);
        } catch (error) {
            console.error('Error fetching deleted professional exams:', error);
        }
    };

    const handleRestore = async (examId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to restore this professional exam?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/professionalExams/restore/${examId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setProfessionalExams(professionalExams.filter(exam => exam.id !== examId));
                        Swal.fire({
                            title: "Restored!",
                            text: "The professional exam has been restored.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to restore professional exam');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to restore the professional exam.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error restoring professional exam:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to restore the professional exam.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handlePermanentDelete = async (examId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete the professional exam. This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete permanently!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/professionalExams/delete/permanent/${examId}`, {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        setProfessionalExams(professionalExams.filter(exam => exam.id !== examId));
                        Swal.fire({
                            title: "Deleted!",
                            text: "The professional exam has been permanently deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete professional exam permanently');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to permanently delete the professional exam.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting professional exam permanently:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to permanently delete the professional exam.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter professional exams based on search term
    const filteredProfExams = professionalExams.filter(exam =>
        (exam.examName && exam.examName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (exam.shortName && exam.shortName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (exam.university && exam.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (exam.instituteEmail && exam.instituteEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (exam.institutePhone && exam.institutePhone.toString().toLowerCase().includes(searchTerm.toLowerCase()))
    );

    return (
        <div>
            <AdminDashboard />

            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>DELETE PROFESSIONAL EXAMS</h1>
                    <form>
                        <input type="text" placeholder='Search Item' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                                <tr>
                                    <th>Exam Name</th>
                                    <th>Short Name</th>
                                    <th>By</th>
                                    <th>Start Date</th>
                                    <th>Contact No.</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredProfExams.map((exam) => (
                                    <tr key={exam.id}>
                                        <td>{exam.examName}</td>
                                        <td>{exam.shortName}</td>
                                        <td>{exam.university}</td>
                                        <td>{new Date(exam.startDate).toLocaleDateString('en-CA')}</td>
                                        <td>{exam.institutePhone}</td>
                                        <td>{exam.instituteEmail}</td>
                                        <td>
                                            <a href={exam.instituteWebsite} target="_blank" rel="noopener noreferrer">
                                                Visit Website
                                            </a>
                                        </td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='restore-details' onClick={() => handleRestore(exam.id)}>RESTORE</a>
                                            <a href="#!" id='del-details' onClick={() => handlePermanentDelete(exam.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteProfExams;
